export default __webpack_public_path__ + "static/media/667.712cf185.gif";